import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <a href="/" className="flex items-center cursor-pointer">
            <span className={`text-2xl font-bold transition-colors ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}>
              DDR CONSTRUCTION SOLUTIONS
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a
              href="/"
              className={`text-base font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-200'
              }`}
            >
              Home
            </a>
            <a
              href="/about"
              className={`text-base font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-200'
              }`}
            >
              About
            </a>
            <a
              href="/projects"
              className={`text-base font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-200'
              }`}
            >
              Projects
            </a>
            <a
              href="/contact"
              className={`text-base font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-200'
              }`}
            >
              Contact
            </a>
            <a
              href="tel:502-533-0524"
              className="px-6 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
            >
              502-533-0524
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 rounded-lg transition-colors ${
              isScrolled ? 'text-gray-900 hover:bg-gray-100' : 'text-white hover:bg-white/10'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden py-4 bg-white rounded-lg shadow-lg mt-2">
            <a
              href="/"
              className="block px-4 py-3 text-gray-700 hover:bg-gray-50 transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Home
            </a>
            <a
              href="/about"
              className="block px-4 py-3 text-gray-700 hover:bg-gray-50 transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              About
            </a>
            <a
              href="/projects"
              className="block px-4 py-3 text-gray-700 hover:bg-gray-50 transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Projects
            </a>
            <a
              href="/contact"
              className="block px-4 py-3 text-gray-700 hover:bg-gray-50 transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Contact
            </a>
            <a
              href="tel:502-533-0524"
              className="block mx-4 mt-2 px-4 py-3 bg-amber-600 text-white text-center rounded-lg hover:bg-amber-700 transition-colors font-medium cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              502-533-0524
            </a>
          </nav>
        )}
      </div>
    </header>
  );
}
